<template>
  <span
    class="tag-v2 semantic-tag inline-flex flex-row items-center gap-1 whitespace-nowrap"
    :class="[sizeClass, `tag-${color}`]"
  >
    <span
      v-if="icon"
      class="material-symbols-outlined leading-none"
      :class="size === 'sm' ? 'text-sm' : 'text-base'"
    >
      {{ icon }}
    </span>
    <slot />
  </span>
</template>

<script>
const SIZE_CLASSES = {
  sm: 'small',
  md: 'medium',
};

export default {
  name: 'TagV2',
  props: {
    color: { type: String, default: 'mute-01' },
    size: {
      type: String,
      default: 'sm',
      validator: value => Object.keys(SIZE_CLASSES).includes(value),
    },
    icon: { type: String, default: '' },
  },
  computed: {
    sizeClass() {
      return SIZE_CLASSES[this.size];
    },
  },
};
</script>
